// Module
var code = "<md-button class=\"md-icon-button md-accent md-hue-1 is-square is-big\" ng-click=\"$ctrl.onClose()\" title=\"{{'DIALOG.CLOSE' | translate}}\"> <md-icon class=\"o-exit-1 tmr-icon-64\"></md-icon> </md-button> ";
// Exports
var _module_exports =code;;
var path = 'components/dialogs/dialogClose/dialogClose.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;